module.exports = __webpack_public_path__ + "static/media/anjana_s.eb568a8e.jpg";